/**
 * Brand constants — single source of truth for the application name and URL.
 * Import this file everywhere the brand name is rendered (header, hero,
 * footer, <title>, <meta>).
 *
 * APP_NAME is NOT localizable (never goes into vue-i18n).
 */
export const APP_NAME = 'Ordiria'

/** Deployment URL (canonical domain, BRANDING §6.5). */
export const APP_URL = 'https://ordiria.app/'

/** Quando true, il pannello di completamento mostra un CTA che rimanda alla
 *  piattaforma ospitata (APP_URL). I build white-label lo mettono a false. */
export const SHOW_CONVERSION_CTA = true

/** Data controller shown on /privacy (Art. 13 GDPR). Values are build env, never committed
 *  (INC-138, ADR-073, SPEC §3). */
export const LEGAL_CONTROLLER = {
  name: import.meta.env.VITE_LEGAL_NAME ?? '',
  location: import.meta.env.VITE_LEGAL_LOCATION ?? '',
  contactEmail: import.meta.env.VITE_LEGAL_CONTACT ?? '',
  authority: 'Garante per la protezione dei dati personali (garanteprivacy.it)',
} as const

/** Date shown as "Last updated" on /privacy. Bump whenever the notice text changes. */
export const PRIVACY_UPDATED = '2026-10-07'

/** Feedback address (Cloudflare Email Routing → maintainer); the invite's Reply-To (ADR-099 D9). */
export const FEEDBACK_EMAIL = 'feedback@ordiria.app'
